// ChargebeeScriptLoader.tsx
import React, {useEffect, useRef} from 'react';
import {useLocation} from "react-router-dom";

const ChargebeeScriptLoader: React.FC = () => {
    const location = useLocation();
    const scriptLoaded = useRef(false);

    useEffect(() => {
        // Initialize Chargebee only on specific routes, e.g., on subscription-related pages
        console.log("Running");
        if (!scriptLoaded.current && location.pathname === '/account/subscription') {
            console.log("Made it");
            const chargebeeScript = document.createElement('script');
            chargebeeScript.src = "https://js.chargebee.com/v2/chargebee.js";
            chargebeeScript.async = true;
            chargebeeScript.onload = () => {
                console.log("Chargebee script loaded successfully");
                if (window.Chargebee) {
                    window.Chargebee.init({
                        site: "vizedi"
                    });
                }
            };
            chargebeeScript.onerror = () => {
                console.error("Failed to load Chargebee script.");
            };

            document.body.appendChild(chargebeeScript);
            scriptLoaded.current = true;
        }
    }, [location]);

    return null;
};

export default ChargebeeScriptLoader;
